import React, { useState, useEffect } from "react";
import "./ourproject.css";
import Aos from "aos";
import "aos/dist/aos.css";
import img from "../../assets/bannerr/1738738558548.jpg";
import img1 from "../../assets/bannerr/1738739449771.jpg";
import img2 from "../../assets/bannerr/1738739750424.jpg";
import img3 from "../../assets/bannerr/1738740214377.jpg";
// import img4 from "../../assets/bannerr/ban.jpg";

function Ourproject() {
  // State to store the carousel items
  const [items, setItems] = useState([
    { id: 1, name: "Chennai", des:"Ground beam shuttering work involves setting up temporary formwork to mold the reinforced concrete ground beams. This includes positioning shuttering panels, ensuring proper alignment, and securing them before pouring concrete to form the beam structure.", image: img },
    { id: 2, name: "Chennai",des:" RCC roof planning involves designing a reinforced concrete structure to ensure strength, durability, and proper load distribution. Execution includes preparing the site, setting up formwork, placing reinforcement, and pouring concrete to create the roof.", image: img2 },
    { id: 3, name: "Chennai",des:"After constructing the building, finishing works such as plastering, flooring, and painting are carried out to enhance the aesthetics and functionality. Final inspections are done to ensure the structure meets safety standards and is ready for occupancy", image: img3 },
    { id: 4, name: "Australia",des:"The real output is a fully built and functional space that aligns with the original design and specifications", image: img1 },
    { id: 5, name: "Netherland",des:"", image: img3 },
    
  ]);

  

  // Function to move first item to the end (Next button)
  const handleNext = () => {
    setItems((prevItems) => [...prevItems.slice(1), prevItems[0]]);
  };

  // Function to move last item to the beginning (Prev button)
  const handlePrev = () => {
    setItems((prevItems) => [prevItems[prevItems.length - 1], ...prevItems.slice(0, -1)]);
  };

  // Auto-slide every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 3000);

    // Cleanup function to clear interval when the component unmounts
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  return (
    <>
   
      <div className="container-fluid  main-con">
        {/* Title Section */}
        

        <div className="slide">
          {items.map((item) => (
            <div key={item.id} className="item" style={{ backgroundImage: `url(${item.image})` }}>
              <div className="content">
                {/* <div className="name" style={{ color:"black"}}>{item.name}</div> */}
                {/* <div className="des" style={{ color:"black"}}>{item.des}</div> */}
                {/* <button>See More</button> */}
              </div>
            </div>
          ))}
        </div>

        <div className="button d-none">
          <button className="prev" onClick={handlePrev}>
            <i className="fa-solid fa-arrow-left"></i>
          </button>
          <button className="next" onClick={handleNext}>
            <i className="fa-solid fa-arrow-right"></i>
          </button>
        </div>
      </div>
    </>
  );
}

export default Ourproject;
